
import React from 'react';
import { Separator } from '@/components/ui/separator';
import AnimateInView from '@/components/ui/animate-in-view';
import GoldSectionDivider from '@/components/ui/gold-section-divider';

export interface TestimonialProps {
  quote: string;
  author: string;
}

interface TestimonialsSectionProps {
  testimonials: TestimonialProps[];
}

const TestimonialsSection: React.FC<TestimonialsSectionProps> = ({ testimonials }) => {
  return (
    <section className="py-16 md:py-24 bg-forti-fi-dark text-white" aria-labelledby="testimonials-heading">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center mb-12">
          <GoldSectionDivider centered />
          <h2 id="testimonials-heading" className="text-center text-white mb-2">Client Testimonials</h2>
          <p className="text-center text-forti-fi-lavender max-w-2xl">
            Hear what our clients are saying about their security transformations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <AnimateInView
              key={index}
              animation="fade-in"
              delay={index * 200}
              className="bg-forti-fi-charcoal/50 p-6 rounded-lg border border-forti-fi-lavender/20"
            >
              <div className="mb-4 text-4xl text-forti-fi-teal">"</div>
              <p className="italic mb-6 text-forti-fi-lavender/90">{testimonial.quote}</p>
              <p className="text-right text-forti-fi-lavender">— {testimonial.author}</p>
            </AnimateInView>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
